import Cartao from '@/components/ui/Cartao';
import Chip from '@/components/ui/Chip';
import type { EstornoFinanceiro } from './tipos';
import { dataHoraBR, reais, rotuloEstorno } from './rotulos';
import Info from './Info';

function Linha({ e }: { e: EstornoFinanceiro }) {
  return (
    <li className="py-3">
      <p className="text-[14px] text-foreground-900">
        {dataHoraBR(e.quando) || '—'} · {rotuloEstorno(e.origem)} ·{' '}
        <span className="whitespace-nowrap tabular-nums">{reais(e.valor)}</span> · {e.quem || '—'}
      </p>
      {e.motivo && <p className="mt-0.5 text-[12px] text-foreground-500">{e.motivo}</p>}
      <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
        {e.dinheiro_devolvido_pelo_mp ? (
          <Chip tipo="success">dinheiro devolvido pelo Mercado Pago</Chip>
        ) : (
          <Chip tipo="secondary">
            só anotado
            <Info texto="O dinheiro não foi devolvido automaticamente." />
          </Chip>
        )}
        {e.era_credito_de_rifa && <Chip tipo="info">crédito de ação entre amigos</Chip>}
      </div>
    </li>
  );
}

export default function BlocoEstornos({ estornos }: { estornos: EstornoFinanceiro[] }) {
  const reais_ = estornos.filter((e) => !e.parece_teste);
  const testes = estornos.filter((e) => e.parece_teste);

  return (
    <Cartao className="p-4">
      <h2 className="text-[17px] font-bold text-foreground-950">Estornos e cancelamentos</h2>

      {reais_.length === 0 ? (
        <p className="mt-2 text-[14px] text-foreground-500">Nenhum estorno.</p>
      ) : (
        <ul className="mt-1 divide-y divide-secondary-100">
          {reais_.map((e, i) => (
            <Linha key={`${e.ref ?? 'e'}-${i}`} e={e} />
          ))}
        </ul>
      )}

      {testes.length > 0 && (
        <details className="mt-3 rounded-2xl bg-background-50 px-3 py-2">
          <summary className="cursor-pointer text-[13px] font-semibold text-foreground-700">
            Testes ({testes.length})
          </summary>
          <ul className="mt-1 divide-y divide-secondary-100">
            {testes.map((e, i) => (
              <Linha key={`${e.ref ?? 't'}-${i}`} e={e} />
            ))}
          </ul>
        </details>
      )}
    </Cartao>
  );
}